import { load } from 'cheerio';

export function extractIOProductDescription(htmlSource: string): string {
    const $ = load(htmlSource);
    return $('.io_product_desc').html() || '';
}
